import { useEffect, useState } from 'react';
import { winnerCards } from '../../data/winners';

const moreProjects = winnerCards
  .filter((winner) => winner.id !== 'winner-2024')
  .filter((winner) => {
    const media = winner.media.toLowerCase();
    return media.includes('film') || media.includes('video');
  })
  .slice(0, 4);

export default function HeehyunChoi() {
  const slides = [
    { src: '/uploads/2024/06/winner-2024-1.png', alt: 'Heehyun Choi work 1' },
    { src: '/uploads/2024/06/winner-2024-2.png', alt: 'Heehyun Choi work 2' },
    { src: '/uploads/2024/06/winner-2024-3.png', alt: 'Heehyun Choi work 3' },
    { src: '/uploads/2024/06/winner-2024-4.png', alt: 'Heehyun Choi work 4' },
  ];
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setActiveSlide((currentSlide) => (currentSlide + 1) % slides.length);
    }, 3500);

    return () => window.clearInterval(intervalId);
  }, [slides.length]);

  return (
    <section className="portfolio-item-page">
      <div className="mx-auto max-w-7xl px-5 py-10 md:px-8">
        <h1 className="subheading uppercase">Heehyun Choi</h1>

        <div className="portfolio-item-intro">
          <div className="portfolio-item-gallery">
            <div className="portfolio-item-slideshow">
              <div className="portfolio-item-slideshow-frame" aria-label="Heehyun Choi slideshow">
                {slides.map((slide, index) => (
                  <img
                    key={slide.src}
                    className={`portfolio-item-slide ${index === activeSlide ? 'portfolio-item-slide-active' : ''}`}
                    src={slide.src}
                    alt={slide.alt}
                    aria-hidden={index !== activeSlide}
                  />
                ))}
              </div>
              <div className="portfolio-item-slideshow-dots" aria-label="Slideshow progress">
                {slides.map((slide, index) => (
                  <button
                    key={slide.src}
                    type="button"
                    className={`portfolio-item-dot ${index === activeSlide ? 'portfolio-item-dot-active' : ''}`}
                    onClick={() => setActiveSlide(index)}
                    aria-label={`Show slide ${index + 1}`}
                    aria-pressed={index === activeSlide}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="portfolio-item-description">
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1.25rem', padding: '0 0' }}>2024</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '2rem 0 0', fontWeight: '700'}}>Juror's Statement</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '0 0' }}>The KAFA juror committee of 2024, comprised of Virginia Moon, Jamillah James, and Pablo José Ramírez, was presented with a strong and diverse pool of applicants. After a lively and critical exchange of compelling viewpoints, the committee agreed to nominate Heehyun Choi for this year's grant. Choi, a film and video artist, through her work delves into examining the inherently accepted social structures in the cinematic world both involving the film apparatuses themselves through performance, often placing herself as the protagonist. She draws upon a wide array of archival material and history to inform her choreography. What impressed us most about Choi's work was its sophisticated handling of ideas, seen and unseen, to expose a social critique of what it means to be a woman filmmaker in Korea. We have no doubt that the expression of her ideas through film and video will only become richer and make an undeniable mark in the burgeoning history of women filmmakers in Korea.</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Jurors</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Virginia Moon, Associate Curator of Korean Art, Los Angeles Contemporary Museum of Art</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Jamillah James, Senior Curator, MCA Chicago</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Pablo José Ramírez, Curator, Hammer Museum</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Biography</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>Heehyun Choi is a moving image artist and educator from Seoul, South Korea, whose practice is grounded on the interest in the physicality and virtuality in projected images, the unseen beings outside the camera frame, and the subjectivity and variability of the act of seeing. Choi received her BA in Art & Technology at Sogang University and MFA in Film & Video at California Institute of the Arts. Her films have been screened internationally including at Seoul Independent Film Festival, Seoul International ALT Cinema & Media Festival (Nemaf), DMZ International Documentary Film Festival, 25 FPS Festival, Images Festival, WNDX Festival of Moving Image, Vienna Shorts Film Festival, Berkeley Art Museum & Pacific Film Archive (BAMPFA), and Ann Arbor Film Festival where she received the Mariam Ghani Juror Award. She is the recipient of WNDX x NIMAC Experimental Moving Image Award, AHL Foundation Artist Fellowship, Alison Doerner Fund for Women Pioneers in Filmmaking, and The Lightning Fund by Los Angeles Contemporary Exhibitions and Andy Warhol Foundation for the Visual Arts.</p>

            <a href='http://www.heehyun.com/' className='nav-link'>Artist's Website</a>
          </div>
        </div>
      </div>

      <section className="portfolio-item-more-projects w-full" aria-labelledby="more-projects-heading">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <h2 className="subheading" id="more-projects-heading" style={{ marginBottom: '1.5rem' }}>
            More projects
          </h2>
        </div>

        <div className="winners-grid portfolio-item-more-grid">
          {moreProjects.map((winner) => (
            <a
              key={winner.id}
              href={winner.href}
              className="winner-card"
              aria-label={`${winner.year} ${winner.media} by ${winner.name}`}
            >
              <img className="winner-card-image" src={winner.image} alt="" />
              <div className="winner-card-overlay">
                <div className="winner-card-portrait-wrap">
                  <img className="winner-card-portrait" src={winner.portrait} alt="" />
                </div>
                <div className="winner-card-copy">
                  <span className="winner-card-meta">
                    {winner.year} | {winner.media}
                  </span>
                  <span className="winner-card-name">{winner.name}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>
    </section>
  );
}
